// Merge field tokens (e.g. {clientName}) use the {fieldName} syntax defined by the
// merge field picker in components/Editor.tsx. These helpers wrap/unwrap them in a
// styled span so they can be visually highlighted without changing the underlying
// template text that gets saved and merged into outgoing emails.
export const mergeFieldTokenClassName = 'mergeFieldToken';

const mergeFieldPattern = /\{[A-Za-z0-9_]+\}/g;
// Lenient on purpose: TinyMCE's own DOM serialization can add attributes (data-mce-*, extra
// classes) or normalize quote style to the span it's displaying, so this matches any <span>
// whose class list contains mergeFieldToken, regardless of what else is on the tag, and keeps
// only the inner {fieldName} text.
const styledMergeFieldPattern = new RegExp(`<span[^>]*class=["'][^"']*\\b${mergeFieldTokenClassName}\\b[^"']*["'][^>]*>(\\{[A-Za-z0-9_]+\\})<\\/span>`, 'g');

// Matches either a whole tag (`<...>`) or a merge field — alternation lets us walk the string
// once and skip over tags as indivisible chunks, so a merge field used inside an attribute value
// (e.g. href="{formLink}") is left untouched instead of being wrapped and breaking the tag.
const tagOrMergeFieldPattern = new RegExp(`(<[^>]*>)|(${mergeFieldPattern.source})`, 'g');

export const styleMergeFields = (html: string): string => {
    // contenteditable="false" makes the span an atomic, non-editable "chip" — without it, the
    // cursor can sit inside the span's formatting context, so typing right after a merge field
    // (or on the next line, if it's the last thing on the line) inherits its blue/monospace style.
    return html.replace(tagOrMergeFieldPattern, (_match, tag, field) => {
        if (tag) {
            return tag;
        }
        return `<span class="${mergeFieldTokenClassName}" contenteditable="false">${field}</span>`;
    });
};

export const unstyleMergeFields = (html: string): string => {
    return html.replace(styledMergeFieldPattern, '$1');
};
